import Checkbox from "common/components/ui/Checkbox";

import type { ReactNode } from "react";

export default function ListSelection<
  OptionType extends Record<string, string | number | boolean> & {
    id: string;
    checked?: boolean;
  },
>({
  countKey,
  options,
  onSelect,
  renderLabel,
}: {
  countKey: keyof OptionType;
  options: OptionType[];
  onSelect: (selectedOption: OptionType) => void;
  renderLabel: (option: OptionType) => ReactNode;
}) {
  return (
    <div className="flex max-h-[216px] flex-col overflow-y-auto scrollbar-thin">
      {options.map((option) => (
        <button
          type="button"
          className="group flex h-9 shrink-0 items-center gap-x-1.5 rounded-xl px-2 hover:bg-black-100 disabled:cursor-not-allowed disabled:text-black-400 disabled:hover:bg-transparent"
          key={option.id}
          onClick={() => onSelect(option)}
        >
          <Checkbox checked={option.checked} isStyleOnly />
          <span className="line-clamp-1 flex-1 text-left text-sm-medium">
            {renderLabel(option)}
          </span>
          {option[countKey] !== 0 && (
            <span className="text-xs text-black-500 group-disabled:text-black-400">
              {option[countKey]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
